import { displayCount } from "@utils/utils";
import ReactCountryFlag from "react-country-flag";
import ReactTooltip from "react-tooltip";

const getMatchScore = (score) => {
  const colors = score > 70 ? "tw-bg-[#f6fef9] tw-border-[#039855]" : "tw-bg-[#fffdf5] tw-border-[#fcca3d]";
  return <span className={`${colors} tw-border tw-rounded-2xl tw-text-xs tw-text-gray-900 tw-px-1.5 tw-w-fit tw-truncate`}>Match Score - {score}%</span>;
};

const CompanyCardView = ({ tableData, setSelectedRowData, selectedRows, setSelectedRows, getSlugHandler, onTrackViewContacts, onTrackBookmark }) => {
  const handleCheckboxChange = (e, row) => {
    if (e.target.checked) {
      setSelectedRows((prev) => [...(prev || []), row]);
    } else {
      setSelectedRows((prev) => (prev || []).filter((data) => data.hashed_id !== row.hashed_id));
    }
  };

  return (
    <div className="tw-space-y-3 tw-mt-3">
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="actions" />

      {tableData?.map((row) => {
        const tickerData = row.stockTickerDetails ? Object.entries(row.stockTickerDetails) : [];
        const identifiers = row.company_identifiers ? row.company_identifiers : {};
        const hasIdentifiers = row.lei || (tickerData && tickerData.length > 0) || Object.keys(identifiers).length > 0 || row.ruc;
        const isChecked = selectedRows?.some((data) => data.hashed_id === row.hashed_id) || false;
        const hasValues = (row.import_value || row.export_value) > 0;
        const isLocked = row.locked ?? false;

        return (
          <div key={row.hashed_id} className="tw-border tw-border-gray-200 tw-p-3 tw-rounded-xl tw-bg-white">
            <div className="tw-flex tw-gap-3">
              <input type="checkbox" checked={isChecked} onChange={(e) => handleCheckboxChange(e, row)} className="tw-h-4 tw-w-4 tw-mt-1 tw-rounded tw-border-gray-200 tw-accent-primary-purple-600 tw-cursor-pointer disabled:tw-cursor-not-allowed" aria-label={`Select ${row.key}`} />
              <div className="tw-w-full">
                <div className="tw-flex tw-justify-between">
                  <div className="tw-w-4/5">
                    <span className="tw-text-primary-purple-600 tw-font-semibold tw-underline tw-capitalize tw-text-sm tw-cursor-pointer tw-pe-2" onClick={() => getSlugHandler(row.hashed_id, isLocked ? "&profileLocked=true" : "")} role="button">
                      {row.key}
                      <svg className="tw-ms-1" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
                        <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z" />
                      </svg>
                    </span>
                    {row.nameMatchPercentage && getMatchScore(row.nameMatchPercentage)}
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {!isLocked && (
                      <button
                        data-for="actions"
                        data-tip="View Contacts"
                        className="tw-cursor-pointer tw-rounded-lg tw-border tw-bg-primary-purple-100 tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-border-none"
                        onClick={() => {
                          onTrackViewContacts?.();
                          getSlugHandler(row.hashed_id, "&redirectTab=contacts");
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#101828">
                          <path d="M202-104.31v-52h556v52H202Zm0-699.38v-52h556v52H202ZM480-412q45.77 0 77.88-32.11Q590-476.23 590-522t-32.12-77.88Q525.77-632 480-632q-45.77 0-77.88 32.12Q370-567.77 370-522q0 45.77 32.12 77.89Q434.23-412 480-412ZM180.31-212q-27.01 0-45.66-18.66Q116-249.32 116-276.35v-407.62q0-27.03 18.65-45.53t45.66-18.5h599.38q27.01 0 45.66 18.66Q844-710.68 844-683.65v407.62q0 27.03-18.65 45.53T779.69-212H180.31Zm68.85-52q48-49.31 107.69-74.65Q416.54-364 480-364q63.46 0 123.15 25.35 59.69 25.34 107.69 74.65h68.85q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-407.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H180.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v407.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h68.85Zm79.84 0h302q-34-24-72.08-36t-79-12Q439-312 401-300t-72 36Zm151-200q-24.25 0-41.12-16.87Q422-497.75 422-522q0-24.24 16.88-41.12Q455.75-580 480-580q24.25 0 41.12 16.88Q538-546.24 538-522q0 24.25-16.88 41.13Q504.25-464 480-464Zm0-16Z" />
                        </svg>
                      </button>
                    )}
                    <button
                      data-for="actions"
                      data-tip="Bookmark"
                      onClick={() => {
                        onTrackBookmark?.();
                        setSelectedRowData([row]);
                      }}
                      className="tw-cursor-pointer tw-rounded-lg tw-border tw-bg-primary-purple-100 tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-border-none"
                      aria-label="Favorite">
                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#101828">
                        <path d="m352-293 128-76 129 76-34-144 111-95-147-13-59-137-59 137-147 13 112 95-34 144Zm-79 107.46 55.31-231.77-183.46-155.92 240.61-20.92L480-812.84l94.54 219.69 240.61 19.92-183.46 155.92L687-185.54 480-308.46 273-185.54ZM480-477Z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className={`tw-mt-1 tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-3`}>
                  {row.address}&nbsp;{row.state}&nbsp;
                  {row.country_code && (
                    <span className={"tw-text-gray-900"}>
                      <ReactCountryFlag svg countryCode={row.country_code} /> {row.country}
                    </span>
                  )}
                </div>
                {hasIdentifiers && (
                  <div className="tw-text-gray-900 tw-mt-1 tw-flex tw-gap-3 tw-flex-wrap">
                    {row.lei && (
                      <div className="tw-border-l-[3px] tw-ps-1 tw-border-[#185cda] tw-text-xs tw-flex tw-items-center">
                        LEI Number:<span className="tw-ms-2 tw-font-medium">{row.lei}</span>
                      </div>
                    )}
                    {tickerData.length > 0 && (
                      <div className="tw-border-l-[3px] tw-ps-1 tw-border-[#6da0f7] tw-text-xs tw-flex tw-items-center">
                        Stock Ticker:
                        <div className="tw-ms-2 tw-font-medium">{tickerData.map(([key, val]) => `${key}: ${val}`).join(", ")}</div>
                      </div>
                    )}
                    {identifiers &&
                      Object.keys(identifiers).length > 0 &&
                      Object.keys(identifiers).map((item) => {
                        const values = identifiers[item].split(",").map((v) => v.trim());
                        const firstValue = values[0];
                        const remainingCount = values.length - 1;

                        return (
                          <div key={item} className="tw-border-l-[3px] tw-ps-1 tw-border-[#6da0f7] tw-text-xs tw-flex tw-items-center tw-mt-0">
                            {item}
                            <div className="tw-ms-2 tw-font-medium tw-flex tw-items-center tw-gap-1">
                              {firstValue}
                              {remainingCount > 0 && (
                                <span data-for={`tooltip-${item}`} data-tip={values.slice(1).join(", ")} className="green-badge">
                                  +{remainingCount}
                                </span>
                              )}
                            </div>
                            {remainingCount > 0 && <ReactTooltip id={`tooltip-${item}`} place="top" effect="solid" className="tw-max-w-[500px] tw-opacity-100" />}
                          </div>
                        );
                      })}
                    {row.ruc && (
                      <div className="tw-border-l-[3px] tw-ps-1 tw-border-[#bfd5f9] tw-text-xs tw-flex tw-items-center">
                        RUC:<span className="tw-ms-2 tw-font-medium">{row.ruc}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {hasValues && (
              <div className="tw-mt-3 tw-ms-7 tw-border-dashed tw-border-t tw-border-t-gray-300 tw-pt-4 tw-flex tw-text-sm tw-font-normal tw-gap-8">
                {row.import_value > 0 && (
                  <div className="tw-w-1/2">
                    <div className="tw-text-gray-700">Imports in Last 12 months</div>
                    <div className="tw-text-gray-900 tw-tracking-[-0.14px]">USD {displayCount(row.import_value, 2)}</div>
                  </div>
                )}
                {row.export_value > 0 && (
                  <div className="tw-w-1/2">
                    <div className="tw-text-gray-700">Exports in Last 12 months</div>
                    <div className="tw-text-gray-900 tw-tracking-[-0.14px]">USD {displayCount(row.export_value, 2)}</div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CompanyCardView;
